import React, { useState, useRef } from 'react';
import template from 'lodash/template';
import PropTypes from 'prop-types';

import { GearIcon } from '@glu/icons-react/lib';

import WidgetMenu from 'components/widgetMenu/WidgetMenu';
import useLocale from 'components/useLocale';

import useStyles from './widgetMenuToggle.styles';

export const WidgetMenuToggleComponent = ({
  onRemoveClick,
  onResizeClick,
  showRemove,
  showResize,
  widgetId,
  widgetName
}) => {
  const locale = useLocale();
  const menuToggleRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { toggle: toggleClass } = useStyles();

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const toggleWithCallback =
    (callback) =>
    (...args) => {
      toggle();
      callback(...args);
    };

  return (
    showRemove &&
    showResize && (
      <div ref={menuToggleRef} className={toggleClass} data-qa={`widget-menu-${widgetId}`}>
        <button
          aria-expanded={open}
          aria-controls={`widgetMenu-${widgetId}`}
          onClick={toggle}
          data-qa="widget-menu-toggle-gear-icon"
        >
          <span className="sr-only">
            {template(locale['screenReader.widgetMenu'])({ widgetName })}
          </span>
          <GearIcon aria-hidden />
        </button>
        {open && (
          <WidgetMenu
            open={open}
            onClose={toggle}
            onRemoveClick={toggleWithCallback(onRemoveClick)}
            onResizeClick={toggleWithCallback(onResizeClick)}
            showRemove
            showResize
            widgetId={widgetId}
            menuToggleRef={menuToggleRef}
          />
        )}
      </div>
    )
  );
};

WidgetMenuToggleComponent.defaultProps = {
  showRemove: true,
  showResize: true
};

WidgetMenuToggleComponent.propTypes = {
  onRemoveClick: PropTypes.func.isRequired,
  onResizeClick: PropTypes.func.isRequired,
  showRemove: PropTypes.bool,
  showResize: PropTypes.bool,
  widgetId: PropTypes.string.isRequired,
  widgetName: PropTypes.string.isRequired
};

export default WidgetMenuToggleComponent;
